import { ReactNode } from 'react';

interface ScrollAnimationProps {
  children: ReactNode;
  animation?: 'fade-in' | 'slide-up' | 'slide-in-left' | 'slide-in-right';
  delay?: number;
}

export default function ScrollAnimation({
  children,
}: ScrollAnimationProps) {
  return (
    <div>
      {children}
    </div>
  );
}
